import React, { useState } from 'react';
import { NButton, NDialog, NTextArea } from '@innersource-nn/novoui-react';
import useRejectShareObjectMutation from 'views/Shares/hooks/useRejectShareObjectMutation';
import { ModalProps } from 'types/Modal';

export interface RejectRequestModalProps extends ModalProps {
    shareUri: string;
    onSubmit: () => void;
}

export default function RejectRequestModal({
    visible,
    onClose,
    shareUri,
    onSubmit,
}: RejectRequestModalProps) {
    const [reason, setReason] = useState<string>('');
    const useRejectShareRequest = useRejectShareObjectMutation(shareUri);
    const [loading, setLoading] = useState<boolean>(false);
    const useReject = async () => {
        setLoading(true);
        await useRejectShareRequest(reason);
        setLoading(false);

        onSubmit();
        if (onClose) onClose();
    };
    return (
        <NDialog
            disabled={loading}
            isVisible={visible}
            closeDialog={onClose}
            backgroundClose
            headline="Deny share request"
            size="medium"
            subHeadline="Are you sure you want to deny access to all requested objects within this share request?"
            showDividers={false}
        >
            <div>
                <NTextArea
                    label="Reason for denial"
                    variant="outline"
                    modelValue={reason}
                    onChange={(event: React.ChangeEvent<HTMLTextAreaElement>) =>
                        setReason(event.target.value)
                    }
                    placeholder="Please provide a short comment or explanation regarding the denial of access."
                />
            </div>
            <div className="py-8 flex gap-8 justify-end">
                <NButton
                    onClick={onClose}
                    variant="outline"
                    size="medium"
                    square
                >
                    Cancel
                </NButton>
                <NButton
                    onClick={useReject}
                    variant="destructive"
                    size="medium"
                    square
                >
                    Deny request
                </NButton>
            </div>
        </NDialog>
    );
}
